import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  actionButton: {
    cursor: 'pointer',
    height: '15px',
    margin: '0px',
    padding: '0px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
}));

type Props = {
  disableDown: boolean;
  disableUp: boolean;
  handleDownClick: Function;
  handleUpClick: Function;
};

const GridRowOrderAction = ({ disableDown, disableUp, handleDownClick, handleUpClick }: Props) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        <IconButton
          className={classes.actionButton}
          id="action-up-button"
          onClick={() => handleUpClick()}
          disabled={disableUp}
        >
          <ArrowDropUp />
        </IconButton>
        <IconButton
          className={classes.actionButton}
          id="action-down-button"
          disabled={disableDown}
          onClick={() => handleDownClick()}
        >
          <ArrowDropDown />
        </IconButton>
      </div>
    </>
  );
};

export default GridRowOrderAction;
